import styled from '@emotion/styled';

export const Container = styled.span`
	display: flex;
	align-items: center;
	width: 100%;
	border: 0.75px solid var(--border-color);
	background-color: var(--input-disabled-bg-color);
	color: var(--content-4);
	border-radius: var(--small-border-radius);
	min-height: 4.2rem;

	> .typography {
		white-space: nowrap !important;
		margin-left: var(--inputPadding);
		body[dir='rtl'] & {
			margin-left: unset;
			margin-right: var(--inputPadding);
		}
	}

	> div {
		display: flex;
		margin-left: auto;

		&[disabled] {
			cursor: default;
		}
	}
`;
